<template>
  <Layout>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :z-index="zIndex"></loading>
    <PageHeader title="Candidate Personal Data and CV"/>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <navigation :item="2" :save="save" :user="user"></navigation>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <p>
                  <b>Candidate e-mail:</b> {{ candidate.email }}
                </p>
              </div>
              <div v-if="candidate.name || candidate.surname" class="col-md-4">
                <p>
                  <b>Candidate name:</b> {{ candidate.name }} {{ candidate.surname }}
                </p>
              </div>
            </div>
            <div class="row">
              <div v-if="candidate.curriculum && candidate.curriculum.length > 0" class="col-md-12 mt-2">
                <curriculum-navigation :id="candidate.curriculum[0].id" :user="user" :agency="agency" />
              </div>
              <div v-else class="col-md-12 mt-2">
                <div class="alert alert-warning mb-3">
                  <b>Warning</b> no curriculum found.
                </div>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import navigation from './navigation'
import axios from 'axios'
import curriculumNavigation from '../curriculum/curriculumNavigation'

export default {
  components: { Layout, PageHeader, loading, navigation, curriculumNavigation },
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    }
  },
  data () {
    return {
      candidate: {},
      curriculumItem: {},
      curriculumId: '',
      isLoading: false,
      fullPage: false,
      zIndex: 9999
    }
  },
  created: function() {
      this.loadCandidate()
  },
  methods: {
    ...authMethods,
    loadCandidate () {
      axios.get(`${appConfig.apiUrl}candidate/me`,
        { headers: { 'Authorization': `Bearer ${this.user.access_token}`, 'content-type': 'application/x-www-form-urlencoded' } } )
      .then((response) => {
        this.candidate = response.data
      })
      .catch(error => {
        this.loginCheck(error.response.status)
        this.$notify({group: 'alert', type: 'warn', title: 'Request Error', text: error});
      });
    },
    save(nextTab) {
      this.$router.push('/app/self-cv/' + nextTab)
    }
  }
}
</script>
